import { TreeNode } from "shared/types/TreeNode"

export function hasChildren<T>(item: TreeNode<T>): item is TreeNode<T> {
  return Object.hasOwn(item, "children")
}
